const isYmdDate = (date: string) => /^(\d{4})-(0?[1-9]|1?[012])-(0?[1-9]|[12]\d|3[01])$/.test(date);

const isDmyDate = (date: string) => /^(0?[1-9]|[12]\d|3[01])\/(0?[1-9]|1?[012])\/(\d{4})$/.test(date);

export const isAutoFilledFromBackend = (date: string) => /\d{2}\/\d{2}\/\*\*\*\*/.test(date);

export const dateIsValid = (date?: string) => {
  if (!date) return false;
  return isYmdDate(date) || isDmyDate(date);
};

const parse = (value: string, split: '/' | '-', join: '/' | '-') =>
  value
    .replace(/^(\d{2,4}[-/]\d{2}[-/]\d{2,4}).*/, '$1')
    .split(split)
    .reverse()
    .join(join);

export const dateDmyToYmd = (value: string) => {
  if (!value) return '';

  return parse(value, '/', '-');
};

export const dateYmdToDmy = (value: string) => {
  if (!value) return '';

  return parse(value, '-', '/');
};

export const dateGetTimestamp = (value: string) => {
  const date = isYmdDate(value) ? value : dateDmyToYmd(value);
  return Date.parse(date);
};

export const dateSubstractYear = (date: Date, years: number) => {
  const localDate = date.getTime();
  const yearsTimestamp = Math.floor(years * 365.25) * 24 * 60 * 60 * 1000;

  return new Date(localDate - yearsTimestamp);
};

export const dateAddYear = (date: Date, years: number) => {
  const localDate = new Date(date);
  localDate.setFullYear(localDate.getFullYear() + years);
  return localDate;
};

export const birthdateRange = () => {
  const now = new Date(Date.now());
  const min = dateYmdToDmy(dateSubstractYear(now, 100).toJSON());
  const max = dateYmdToDmy(dateSubstractYear(now, 18).toJSON());
  return { min, max };
};
